<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v"></a>To Ellen who stands by me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedi.vue?7f6e225d